export const BRAND_ACTION_TYPES = {
    SAVE_CREDIT_CARD_REQUEST: 'SAVE_CREDIT_CARD_REQUEST',
    SAVE_CREDIT_CARD_DATA: 'SAVE_CREDIT_CARD_DATA',
    SAVE_CREDIT_CARD_ERROR: 'SAVE_CREDIT_CARD_ERROR',
    SAVE_CREDIT_CARD_RESET: 'SAVE_CREDIT_CARD_RESET',

    VERIFY_COUPON_CODE_REQUEST: 'VERIFY_COUPON_CODE_REQUEST',
    VERIFY_COUPON_CODE_DATA: 'VERIFY_COUPON_CODE_DATA',
    VERIFY_COUPON_CODE_ERROR: 'VERIFY_COUPON_CODE_ERROR',
    VERIFY_COUPON_CODE_RESET: 'VERIFY_COUPON_CODE_RESET',

    ACTIVATE_PLAN_REQUEST: 'ACTIVATE_PLAN_REQUEST',
    ACTIVATE_PLAN_DATA: 'ACTIVATE_PLAN_DATA',
    ACTIVATE_PLAN_ERROR: 'ACTIVATE_PLAN_ERROR',
    ACTIVATE_PLAN_RESET: 'ACTIVATE_PLAN_RESET',

    VIEW_PROFILE_REQUEST: 'VIEW_PROFILE_REQUEST',
    VIEW_PROFILE_DATA: 'VIEW_PROFILE_DATA',
    VIEW_PROFILE_ERROR: 'VIEW_PROFILE_ERROR',

    SAVE_PROFILE_REQUEST: 'SAVE_PROFILE_REQUEST',
    SAVE_PROFILE_DATA: 'SAVE_PROFILE_DATA',
    SAVE_PROFILE_ERROR: 'SAVE_PROFILE_ERROR',
    SAVE_PROFILE_RESET: 'SAVE_PROFILE_RESET',

    RD_GROUP_LIST_REQUEST: 'RD_GROUP_LIST_REQUEST',
    RD_GROUP_LIST_DATA: 'RD_GROUP_LIST_DATA',
    RD_GROUP_LIST_ERROR: 'RD_GROUP_LIST_ERROR',
    RD_GROUP_LIST_RESET: 'RD_GROUP_LIST_RESET',

    RD_IG_DATA_REQUEST: 'RD_IG_DATA_REQUEST',
    RD_IG_DATA_DATA: 'RD_IG_DATA_DATA',
    RD_IG_DATA_ERROR: 'RD_IG_DATA_ERROR',

    COPY_CAMPAIGN_REQUEST: 'COPY_CAMPAIGN_REQUEST',
    COPY_CAMPAIGN_DATA: 'COPY_CAMPAIGN_DATA',
    COPY_CAMPAIGN_ERROR: 'COPY_CAMPAIGN_ERROR',
    COPY_CAMPAIGN_RESET: 'COPY_CAMPAIGN_RESET',

    MASS_MSG_TEMP_SAVE_REQUEST: 'MASS_MSG_TEMP_SAVE_REQUEST',
    MASS_MSG_TEMP_SAVE_DATA: 'MASS_MSG_TEMP_SAVE_DATA',
    MASS_MSG_TEMP_SAVE_ERROR: 'MASS_MSG_TEMP_SAVE_ERROR',
    MASS_MSG_TEMP_SAVE_RESET: 'MASS_MSG_TEMP_SAVE_RESET',

    MASS_MSG_TEMP_LIST_REQUEST: 'MASS_MSG_TEMP_LIST_REQUEST',
    MASS_MSG_TEMP_LIST_DATA: 'MASS_MSG_TEMP_LIST_DATA',
    MASS_MSG_TEMP_LIST_ERROR: 'MASS_MSG_TEMP_LIST_ERROR',

    MASS_MSG_TEMP_DELETE_REQUEST: 'MASS_MSG_TEMP_DELETE_REQUEST',
    MASS_MSG_TEMP_DELETE_DATA: 'MASS_MSG_TEMP_DELETE_DATA',
    MASS_MSG_TEMP_DELETE_ERROR: 'MASS_MSG_TEMP_DELETE_ERROR',
    MASS_MSG_TEMP_DELETE_RESET: 'MASS_MSG_TEMP_DELETE_RESET',

    MARK_AS_READ_REQUEST: 'MARK_AS_READ_REQUEST',
    MARK_AS_READ_DATA: 'MARK_AS_READ_DATA',
    MARK_AS_READ_ERROR: 'MARK_AS_READ_ERROR',
    MARK_AS_READ_RESET: 'MARK_AS_READ_RESET',

    CAMPAIGN_TYPE_REQUEST: 'CAMPAIGN_TYPE_REQUEST',
    CAMPAIGN_TYPE_DATA: 'CAMPAIGN_TYPE_DATA',
    CAMPAIGN_TYPE_ERROR: 'CAMPAIGN_TYPE_ERROR',

    CAMPAIGN_LISTING_REQUEST: 'CAMPAIGN_LISTING_REQUEST',
    CAMPAIGN_LISTING_DATA: 'CAMPAIGN_LISTING_DATA',
    CAMPAIGN_LISTING_ERROR: 'CAMPAIGN_LISTING_ERROR',

    CAMPAIGN_SAVE_REQUEST: 'CAMPAIGN_SAVE_REQUEST',
    CAMPAIGN_SAVE_DATA: 'CAMPAIGN_SAVE_DATA',
    CAMPAIGN_SAVE_ERROR: 'CAMPAIGN_SAVE_ERROR',
    CAMPAIGN_SAVE_RESET: 'CAMPAIGN_SAVE_RESET',

    CAMPAIGN_VIEW_REQUEST: 'CAMPAIGN_VIEW_REQUEST',
    CAMPAIGN_VIEW_DATA: 'CAMPAIGN_VIEW_DATA',
    CAMPAIGN_VIEW_ERROR: 'CAMPAIGN_VIEW_ERROR',
    CAMPAIGN_VIEW_RESET: 'CAMPAIGN_VIEW_RESET',

    DELETE_CAMPAIGN_REQUEST: 'DELETE_CAMPAIGN_REQUEST',
    DELETE_CAMPAIGN_DATA: 'DELETE_CAMPAIGN_DATA',
    DELETE_CAMPAIGN_ERROR: 'DELETE_CAMPAIGN_ERROR',
    DELETE_CAMPAIGN_RESET: 'DELETE_CAMPAIGN_RESET',

    REC_RD_CAMPAIGN_REQUEST: 'REC_RD_CAMPAIGN_REQUEST',
    REC_RD_CAMPAIGN_DATA: 'REC_RD_CAMPAIGN_DATA',
    REC_RD_CAMPAIGN_ERROR: 'REC_RD_CAMPAIGN_ERROR',
    REC_RD_CAMPAIGN_RESET: 'REC_RD_CAMPAIGN_RESET',

    SEC_PUB_CAMPAIGN_REQUEST: 'SEC_PUB_CAMPAIGN_REQUEST',
    SEC_PUB_CAMPAIGN_DATA: 'SEC_PUB_CAMPAIGN_DATA',
    SEC_PUB_CAMPAIGN_ERROR: 'SEC_PUB_CAMPAIGN_ERROR',
    SEC_PUB_CAMPAIGN_RESET: 'SEC_PUB_CAMPAIGN_RESET',

    CAMPAIGN_APP_REQUEST: 'CAMPAIGN_APP_REQUEST',
    CAMPAIGN_APP_DATA: 'CAMPAIGN_APP_DATA',
    CAMPAIGN_APP_ERROR: 'CAMPAIGN_APP_ERROR',

    COPY_CAMPAIGN_V2_REQUEST: 'COPY_CAMPAIGN_V2_REQUEST',
    COPY_CAMPAIGN_V2_DATA: 'COPY_CAMPAIGN_V2_DATA',
    COPY_CAMPAIGN_V2_ERROR: 'COPY_CAMPAIGN_V2_ERROR',
    COPY_CAMPAIGN_V2_RESET: 'COPY_CAMPAIGN_V2_RESET',

    CAMPAIGN_STATUS_REQUEST: 'CAMPAIGN_STATUS_REQUEST',
    CAMPAIGN_STATUS_DATA: 'CAMPAIGN_STATUS_DATA',
    CAMPAIGN_STATUS_ERROR: 'CAMPAIGN_STATUS_ERROR',
    CAMPAIGN_STATUS_RESET: 'CAMPAIGN_STATUS_RESET',

    GET_FAV_FOLDER_REQUEST: 'GET_FAV_FOLDER_REQUEST',
    GET_FAV_FOLDER_DATA: 'GET_FAV_FOLDER_DATA',
    GET_FAV_FOLDER_ERROR: 'GET_FAV_FOLDER_ERROR',
    GET_FAV_FOLDER_RESET: 'GET_FAV_FOLDER_RESET',

    GET_FAV_PROFILE_REQUEST: 'GET_FAV_PROFILE_REQUEST',
    GET_FAV_PROFILE_DATA: 'GET_FAV_PROFILE_DATA',
    GET_FAV_PROFILE_ERROR: 'GET_FAV_PROFILE_ERROR',
    GET_FAV_PROFILE_RESET: 'GET_FAV_PROFILE_RESET',

    MY_RDS_REQUEST: 'MY_RDS_REQUEST',
    MY_RDS_DATA: 'MY_RDS_DATA',
    MY_RDS_ERROR: 'MY_RDS_ERROR',
    MY_RDS_RESET: 'MY_RDS_RESET',

    FAV_FOLDER_LIST_REQUEST: 'FAV_FOLDER_LIST_REQUEST',
    FAV_FOLDER_LIST_DATA: 'FAV_FOLDER_LIST_DATA',
    FAV_FOLDER_LIST_ERROR: 'FAV_FOLDER_LIST_ERROR',

    FAV_FOLDER_CREATE_REQUEST: 'FAV_FOLDER_CREATE_REQUEST',
    FAV_FOLDER_CREATE_DATA: 'FAV_FOLDER_CREATE_DATA',
    FAV_FOLDER_CREATE_ERROR: 'FAV_FOLDER_CREATE_ERROR',
    FAV_FOLDER_CREATE_RESET: 'FAV_FOLDER_CREATE_RESET',

    ADD_TO_FAV_FOLDER_REQUEST: 'ADD_TO_FAV_FOLDER_REQUEST',
    ADD_TO_FAV_FOLDER_DATA: 'ADD_TO_FAV_FOLDER_DATA',
    ADD_TO_FAV_FOLDER_ERROR: 'ADD_TO_FAV_FOLDER_ERROR',
    ADD_TO_FAV_FOLDER_RESET: 'ADD_TO_FAV_FOLDER_RESET',

    FAV_FOLDER_UPDATE_REQUEST: 'FAV_FOLDER_UPDATE_REQUEST',
    FAV_FOLDER_UPDATE_DATA: 'FAV_FOLDER_UPDATE_DATA',
    FAV_FOLDER_UPDATE_ERROR: 'FAV_FOLDER_UPDATE_ERROR',
    FAV_FOLDER_UPDATE_RESET: 'FAV_FOLDER_UPDATE_RESET',

    FAV_FOLDER_DELETE_REQUEST: 'FAV_FOLDER_DELETE_REQUEST',
    FAV_FOLDER_DELETE_DATA: 'FAV_FOLDER_DELETE_DATA',
    FAV_FOLDER_DELETE_ERROR: 'FAV_FOLDER_DELETE_ERROR',
    FAV_FOLDER_DELETE_RESET: 'FAV_FOLDER_DELETE_RESET'
}